import React from 'react'
import PropTypes from 'prop-types'
import { SlotHost, Slot } from 'shared/components'
import Menu from './components/menu'
import * as styles from './styles'

const LayoutComponent = ({ children, isMenuHidden = false }) => (
  <SlotHost>
    <Slot name="layout:header" />
    {!isMenuHidden && <Menu />}
    <section css={styles.contentSection}>{children}</section>
  </SlotHost>
)

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
  isMenuHidden: PropTypes.bool,
}

export default LayoutComponent
